import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1daead86"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "height", "width"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "合成中", -1))

import {LoadingOutlined} from "@ant-design/icons-vue";
import {IThemeImagePreview} from "@/app/editor/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePreview',
  props: {
    image: {},
    height: {},
    width: {},
    radius: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createElementBlock("div", {
    class: "image-preview",
    style: _normalizeStyle({width:_ctx.width,height:_ctx.height, borderRadius:_ctx.radius?'8px':'0',backgroundImage: `url(${_ctx.image.src})`})
  }, [
    (_ctx.width=='auto' || _ctx.height=='auto')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.image.src,
          height: _ctx.height,
          width: _ctx.width,
          alt: ""
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({minWidth: '40px',width: typeof _ctx.width == 'string' ? _ctx.width : _ctx.width+'px',height:typeof _ctx.height == 'string' ? _ctx.height : _ctx.height+'px', backgroundImage: `url(${_ctx.image.src})`, backgroundSize:'cover', borderRadius:_ctx.radius?'8px':'0'})
        }, null, 4)),
    (_ctx.image.loading)
      ? (_openBlock(), _createBlock(_component_a_flex, {
          key: 2,
          vertical: "",
          gap: "small",
          align: "center",
          justify: "center",
          class: "mask"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LoadingOutlined)),
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})